'use client';

import { useState, ChangeEvent, useEffect } from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';

import { TCountryCurrency, useDebouncedCallback } from '@northladder/utilities';

import { CircularProgressLoader } from '../../../loaders';

interface IBidPriceTextField {
  /**
   * Initial Value of the input field
   */
  spotPrice: number;
  /**
   * Minimum update value (it will say need to increase at least this amount)
   */
  minUpdateValue: string;
  /**
   * Currency type or currency name eg: AED, USD etc..
   */
  currency: TCountryCurrency;
  /**
   * Callback supplied to the parent component to provide the updated value.
   */
  onUpdateSpotPrice: (newSpotPrice: string) => void;
  isUpdatingSpotPrice: boolean;
}

/**
 * A InputField. It will only accept number values It have one submit button for
 * sending the data to the parent or call the api in this component. it have the
 * validation to check the input field data is valid or not if it is truthy then
 * it will allow to click the button
 * @deprecated- To be deleted later
 */
export function BidPriceTextField({
  spotPrice = 0,
  currency = 'AED',
  minUpdateValue = '10',
  onUpdateSpotPrice,
  isUpdatingSpotPrice: loading,
}: IBidPriceTextField) {
  // state for capturing onchange data from input field
  const [inputFieldData, setInputFieldData] = useState('');

  useEffect(() => {
    // add initial price to field
    setInputFieldData(spotPrice.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // this function will interact with `useDebounce` and give the inputData after
  // the time interval
  const handleSubmitOnChangeData = (inputData: string) => {
    setInputFieldData(inputData);
  };

  // handling click event for check icon submit button
  const handleOnClick = () => {
    if (!inputFieldData) return;
    onUpdateSpotPrice(inputFieldData);
  };

  const onInputChangeDebounced = useDebouncedCallback(
    handleSubmitOnChangeData,
    { wait: 500 }
  );

  // taking input from input field and updating the debounce values
  // `setInputValue` ,`debouncedHandleChange`
  const handleOnTextChange = (inputData: ChangeEvent<HTMLInputElement>) => {
    const data = inputData.target.value;
    setInputFieldData(data);
    onInputChangeDebounced(data);
  };

  return (
    <div className="flex w-fit flex-col">
      <div className="relative flex w-fit flex-row">
        <input
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          className="m-0 h-10 w-28 border-gray-300 pr-10 text-sm font-medium text-black"
          onChange={handleOnTextChange}
          placeholder="price"
          type="number"
          value={inputFieldData}
        />
        <button
          className="
            absolute right-[-5px] flex h-10 w-10 flex-row items-center justify-center
            rounded-md bg-black text-white
          "
          onClick={handleOnClick}
          type="submit"
        >
          {loading ? (
            <CircularProgressLoader className="stroke-white" />
          ) : (
            <CheckIcon className="h-7 p-1" />
          )}
        </button>
      </div>
      <p className="self-center text-xs font-normal text-slate-400">
        {`Min. update ${currency} ${minUpdateValue}`}
      </p>
    </div>
  );
}
